

export const CREATE_USER_FORM_MOVE_TO_CUTTING = 'CREATE_USER_FORM_MOVE_TO_CUTTING';

export const FETCH_PROGRAM_FOR_MOVE_TO_CUTTING_REQUEST = 'FETCH_PROGRAM_FOR_MOVE_TO_CUTTING_REQUEST';
export const FETCH_PROGRAM_FOR_MOVE_TO_CUTTING_SUCCESS = 'FETCH_PROGRAM_FOR_MOVE_TO_CUTTING_SUCCESS';
export const FETCH_PROGRAM_FOR_MOVE_TO_CUTTING_FAILURE = 'FETCH_PROGRAM_FOR_MOVE_TO_CUTTING_FAILURE';

export const FETCH_DASHBOARD_DATA_OF_MOVE_TO_CUTTING_REQUEST = 'FETCH_DASHBOARD_DATA_OF_MOVE_TO_CUTTING_REQUEST';
export const FETCH_DASHBOARD_DATA_OF_MOVE_TO_CUTTING_SUCCESS = 'FETCH_DASHBOARD_DATA_OF_MOVE_TO_CUTTING_SUCCESS';
export const FETCH_DASHBOARD_DATA_OF_MOVE_TO_CUTTING_FAILURE = 'FETCH_DASHBOARD_DATA_OF_MOVE_TO_CUTTING_FAILURE';